export type RegisterPropertyInterestResult = {
    data: {
        registerPropertyInterest: {
            result: "Registered" | "AlreadyRegistered";
        } | null;
    };
};

export const registerPropertyInterestMutation = `
  mutation RegisterPropertyInterest($propertyNumber: String!, $email: String!) {
    registerPropertyInterest(propertyNumber: $propertyNumber, email: $email) {
      result
    }
  }
`;

export type ConfirmPropertyInterestResult = {
    data: {
        confirmPropertyInterest: boolean | null;
    };
};

export const confirmPropertyInterestMutation = `
  mutation ConfirmPropertyInterest($token: String!) {
    confirmPropertyInterest(token: $token)
  }
`;
